import React from 'react';
import { useContent } from '../context/ContentContext';
import PostDetail from '../components/PostDetail';

function LinkAnalyzer() {
  const { blogs } = useContent();

  return (
    <div>
      <PostDetail blogs={blogs} />
    </div>
  );
}

export default LinkAnalyzer;
